// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { legacyManufacturerStyles } from "@flip/App/Components/Product/LegacyManufacturer";
import xProductPartNumbersStyles from "@flip/App/SharedStyle/ProductPartNumbersStyles";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { color, xScreen } from "@flip/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

legacyManufacturerStyles.nameText = {
    size: 13,
    color: "text",
    css: css`
        line-height: 13px;
        margin-bottom: 4px;
    `,
};

legacyManufacturerStyles.nameLink = {
    css: css`
        ${wrapInContainerStyles};
        ${({ isAuthorized }: any) =>
            isAuthorized
                ? css`
                      @media print {
                          color: ${color("primary.main")} !important;
                      }
                  `
                : css`
                      &&& {
                          ${TypographyStyle} {
                              color: ${color("text")};
                              &:visited {
                                  color: ${color("text")};
                              }
                              &:hover {
                                  color: ${color("secondary")};
                              }
                          }
                      }
                  `}
    `,
    typographyProps: {
        size: "13px",
        weight: 600,
    },
};

legacyManufacturerStyles.brandNotClickable = {
    size: "13px",
    color: "text.link",
    css: css`
        ${wrapInContainerStyles};
        ${({ isAuthorized }: any) =>
            isAuthorized
                ? css`
                      @media print {
                          color: ${color("primary.main")} !important;
                      }
                  `
                : css`
                      &&& {
                          color: ${color("text")};
                      }
                  `}
    `,
};

legacyManufacturerStyles.labelText = {
    size: 12,
    weight: fontConfig.weight.semiBold,
    transform: "capitalize",
    color: "text",
    css: css`
        letter-spacing: 0;
        line-height: 13px;
        margin-right: 4px;
        flex-shrink: 0;
        display: inline-block;

        &:after {
            content: ":";
        }
    `,
};

legacyManufacturerStyles.wrapper = {
    css: css`
        margin-bottom: 10px;
        line-height: 14px;
        padding-top: 2px;
    `,
};
